import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const CreditCard = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '16',
    defaultHeight: '16',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        d='M13.3359 3.33398H2.66927C1.93289 3.33398 1.33594 3.93094 1.33594 4.66732V11.334C1.33594 12.0704 1.93289 12.6673 2.66927 12.6673H13.3359C14.0723 12.6673 14.6693 12.0704 14.6693 11.334V4.66732C14.6693 3.93094 14.0723 3.33398 13.3359 3.33398Z'
        stroke={primaryColorToUse}
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.33594 6.66602H14.6693'
        stroke={primaryColorToUse}
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
